module.exports = __webpack_public_path__ + "img/Character_Eula_Thumb.e32ad506.png";